import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import React, { FC, useContext, useState } from 'react';
import { EditBusinessExpertModal } from './Modals/EditBusinessExpertModal';
import { getFullName } from '../utils/utils';
import { BusinessContext } from '../BusinessProvider/BusinessProvider';

interface Props {}

const BusinessEditExpert: FC<Props> = (props) => {
  const classes = useStyles();
  const { businessState, canEditBusiness } = useContext(BusinessContext);
  const [openModal, setOpenModal] = useState<boolean>(false);
  return (
    <>
      <Grid item xs={12} sm={3} className={classes.left}>
        <Typography className={classes.label}>Mandataire expert :</Typography>
      </Grid>
      <Grid item xs={11} sm={8} className={classes.left}>
        <Typography>
          {getFullName({
            firstName: businessState?.mandatary?.firstName || '',
            lastName: businessState?.mandatary?.lastName || '',
          })}
        </Typography>
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {canEditBusiness && (
          <EditIcon
            className={classes.icon}
            onClick={() => setOpenModal(true)}
          />
        )}
      </Grid>
      {openModal && (
        <EditBusinessExpertModal onClose={() => setOpenModal(false)} />
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

export default BusinessEditExpert;
